import React, { useState, useEffect, useContext } from "react";
import { RoleContext } from "../../contexts/RoleContext";
import { AuthContext } from "../../contexts/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import Notification from "../../components/UI/Notification";
import DeleteButton from "../../components/UI/AlertDialog";
import { getRoleBasedRoute } from "../../utils/routeUtils";

const ManageRoles = () => {
  const { roles, loadRoles, addRole, deleteARole, loading, error, clearError } = useContext(RoleContext);
  const { roles: userRoles } = useContext(AuthContext);
  const [newRole, setNewRole] = useState("");
  const [success, setSuccess] = useState("");
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate(); // For navigation to the edit role page
  const [notification, setNotification] = useState(null);

  // Helper function to generate role-based routes
  const getRoleBasedRouteLocal = (route) => {
    return getRoleBasedRoute(route, userRoles);
  };

  useEffect(() => {
    if (token) {
      loadRoles(token);
    }
  }, [token, loadRoles]);

  // Log roles whenever they change
  useEffect(() => {
  }, [roles]);

  const handleCreateRole = async () => {
    clearError();
    setSuccess("");
    if (!newRole.trim()) {
      // setSuccess("Role name cannot be empty.");
      // setNotification("Role name cannot be empty.");
      setNotification({
        message: "Role name cannot be empty.",
        type: "error",
      });
      return;
    }
    // try {
    const response = await addRole(token, { name: newRole });
    // console.log("result from users page: ", response)
    // setNotification("Role created successfully.");
    setNotification({
      message: "Role created successfully.",
      type: "success",
    });
    setNewRole("");
    if (response?.success === true) {
      // setNotification("Role created successfully.");
      setNotification({
        message: "Role created successfully.",
        type: "success",
      });
    } else {
      if (response?.fieldErrors?.name?.length > 0) {
        // setNotification(`Error: ${response.fieldErrors.name[0]}`);
        setNotification({
          message: `Error: ${response.fieldErrors.name[0]}`,
          type: "error",
        });
      } else {
        // setNotification(`Error: ${response?.message || "Failed to add role."}`);
        setNotification({
          message: `Error: ${response?.message || "Failed to add role."}`,
          type: "error",
        });
      }
    }
    // } catch {
    //   // Errors are handled via the `error` state in the context
    // }
  };

  const handleEditRole = (roleId) => {
    navigate(getRoleBasedRouteLocal(`/admin/edit-role/${roleId}`)); // Navigate to the edit role page with the role ID
    // setNotification("Role updated");
    setNotification({
      message: "Role updated",
      type: "success",
    });
  };

  const handleDeleteRole = async (roleId) => {
    try {
      await deleteARole(token, roleId);
      // setNotification("Role deleted");
      setNotification({
        message: "Role deleted",
        type: "success",
      });
    } catch {
      // Errors are handled via the `error` state in the context
      setNotification({
        message: "Failed to delete Role",
        type: "error",
      });
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center p-6 font-poppins">
      {notification && (
          <Notification message={notification.message} type={notification.type} onClose={() => setNotification(null)} />
      )}
      <div className="w-full max-w-xl bg-white dark:bg-gray-900 rounded shadow-md p-6">
        <div className="flex justify-between items-center">
          <h2 className="md:text-2xl text-xl font-semibold text-gray-800 mb-4 text-center dark:text-white">Manage Roles</h2>
          <Link to={getRoleBasedRouteLocal('/admin/assign-roles')} className="text-sm hover:underline hover:underline-offset-4 mb-4 text-blue-500 text-center">Assign Role</Link>
        </div>
        {/* Display error or success messages */}
        {/* {error && <p className="text-red-500 mb-4">{error}</p>} */}
        {success && <p className="text-green-500 mb-4">{success}</p>}

        <div className="mb-6">
          <label className="block text-gray-700 font-medium mb-2 dark:text-white">New Role Name:</label>
          <input
            type="text"
            placeholder="Enter new role name"
            value={newRole}
            onChange={(e) => setNewRole(e.target.value)}
            className="w-full px-4 py-2 dark:bg-black dark:text-white dark:border-gray-700 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <button
          onClick={handleCreateRole}
          className={`w-full py-2 rounded-lg transition duration-200 ${
            newRole.trim() ? "bg-blue-600 text-white hover:bg-blue-700" : "bg-gray-400 text-gray-300 dark:bg-gray-800 dark:text-white cursor-not-allowed"
          }`}
          disabled={!newRole.trim()}
        >
          Add Role
        </button>

        <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4 dark:text-white">All Roles</h3>
        {loading ? (
          <p className="text-gray-500 text-center dark:text-white">Loading roles...</p>
        ) : roles.length === 0 ? (
          <p className="text-gray-500 dark:text-white">No roles available. Add a new role above.</p>
        ) : (
          <ul className="space-y-2">
            {roles.map((role) => (
              <li
                key={role.id}
                className="bg-gray-100 dark:bg-gray-900 dark:text-white dark:border-gray-700 px-4 py-2 rounded shadow-sm border border-gray-200 text-gray-700 flex justify-between items-center"
              >
                <span>{role.name || role}</span>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => handleEditRole(role.id)}
                    className="text-blue-500 hover:text-blue-700 hover:underline hover:underline-offset-4"
                  >
                    Edit
                  </button>
                  <DeleteButton style={`text-red-600 hover:text-red-800 hover:underline hover:underline-offset-4`} onDelete={() => handleDeleteRole(role.id)} />
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default ManageRoles;
